import React from 'react';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import * as Sentry from '@sentry/react';
import BaseConfirmationModal from '../ConfirmationModal';

const ConfirmationModal = styled(BaseConfirmationModal)`
  color: ${({ theme }) => theme.colors.redNegative};
  .content {
    overflow: scroll;
  }
  max-width: 700px;
`;

const Stack = styled.div`
  text-align: left !important;
  padding-top: 16px;
  color: ${({ theme }) => theme.colors.redNegative};
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    const isAnyChunkError =
      error?.toString?.()?.includes?.('Loading chunk') || error?.toString?.()?.includes?.('Loading CSS chunk');
    if (isAnyChunkError) {
      window.location.reload();
      return;
    }
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;
    const { children, t, withMessage = true, accountId, adminId } = this.props;

    if (error) {
      if (!withMessage) {
        return null;
      }

      Sentry.captureException(error, {
        extra: {
          errorInfo: errorInfo?.componentStack?.toString?.(),
          accountId,
          adminId
        }
      });

      return (
        <ConfirmationModal
          onClose={() => this.setState({ error: null })}
          onConfirm={() => this.setState({ error: null })}
          title={t('somethingWentWrong')}
          showCancelButton={false}
          confirmText="ok">
          <Stack>
            {error.toString()}

            {process.env.NODE_ENV !== 'production' && (
              <>
                <br />
                <br />
                {errorInfo?.componentStack?.toString?.()}
              </>
            )}
          </Stack>
        </ConfirmationModal>
      );
    }

    return <>{children}</>;
  }
}

export default withTranslation()(ErrorBoundary);
